// @custom — Product-specific pricing page content overrides.
// This file is NEVER overwritten during template sync.
// Override any keys from @system/pricing.js here.
//
// Example:
// export default {
//   title: 'Plans that scale with you',
//   subtitle: 'No hidden fees. Cancel anytime.',
// }

export default {}
